import { ReactComponent as TickIcon } from "../../../../Assets/Tick.svg";
import styles from "./Packages.module.scss";

interface PackageItem {
  discountRate: number;
  isFamily: boolean;
  isFreeMonth: boolean;
  isMember: boolean;
  isNonMember: boolean;
  noofMember: number;
  packageAmenities: string[];
  packageDescription: string;
  packageId: number;
  packageName: string;
  totalRates: number;
}

interface Props {
  packages: PackageItem[];
  selectedPackageId: number;
  setSelectedPackageId: React.Dispatch<React.SetStateAction<number>>;
}

function Packages(props: Props) {
  const { packages, selectedPackageId, setSelectedPackageId } = props;
  return (
    <div className={styles.mainContainer}>
      <div className={styles.subHeadingContainer}>
        <p className={styles.label}>Select package</p>
      </div>
      {packages?.length === 0 && (
        <div className={styles.noPackageContainer}>
          <p className={styles.text}>No package found</p>
        </div>
      )}
      <div className={styles.packagesContainer}>
        {packages?.map((pack: PackageItem, i: number) => {
          return (
            <div key={i} className={styles.package}>
              <div className={styles.infoContainer}>
                <p className={styles.name}>{pack?.packageName}</p>
                <div className={styles.priceContainer}>
                  {pack?.discountRate > 0 ? (
                    <>
                      <p className={styles.price}>
                        ${pack?.totalRates - pack?.discountRate}/mo
                      </p>
                      <p className={styles.cancelledPrice}>
                        ${pack?.totalRates}/mo
                      </p>
                    </>
                  ) : (
                    <p className={styles.price}>${pack?.totalRates}/mo</p>
                  )}
                </div>
              </div>
              {
                <div className={styles.trialContainer}>
                  {pack?.isFreeMonth && (
                    <p className={styles.label}>
                      This package has a limited time free trial
                    </p>
                  )}
                </div>
              }
              <div className={styles.buttonContainer}>
                <button
                  className={styles.button}
                  onClick={() => setSelectedPackageId(pack?.packageId)}
                >
                  {selectedPackageId === pack?.packageId
                    ? "Selected"
                    : "Select"}
                </button>
              </div>
              <div className={styles.featuresContainer}>
                <p>Plan includes</p>
                {pack?.packageAmenities?.map((amenity: any, j: number) => {
                  return (
                    <div key={j} className={styles.feature}>
                      <div className={styles.iconContainer}>
                        <TickIcon className={styles.icon} />
                      </div>
                      <p className={styles.label}>{amenity}</p>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Packages;
